import * as React from 'react';
import { Flex } from '@lightspeed/flame/Core';
import QRCode from 'qrcode';

import { LoggerScope } from '~/main/utils/logger';
import Logger from '~/renderer/utils/logger';

interface QRCodeImageProps {
  url: string;
}
const QRCodeImage: React.FC<QRCodeImageProps> = ({ url }) => {
  const [dataUri, setDataUri] = React.useState('');

  React.useEffect(() => {
    const generateQRCode = () => {
      if (url) {
        QRCode.toDataURL(url, { margin: 0 })
          .then((data: string) => setDataUri(data))
          .catch(err => {
            // eslint-disable-next-line no-console
            console.error('Error generating QR code:', err);
          });

        Logger({ scope: LoggerScope.CFD, transport: LoggerScope.ABLY_CUSTOMER }).debug({ url });
      }
    };
    generateQRCode();
  }, [url]);

  return dataUri ? (
    <Flex style={{ background: '#fff', padding: 6 }}>
      <img src={dataUri} alt="CFD QR Code" style={{ width: '160px' }} data-testid="qrcode-img" />
    </Flex>
  ) : null;
};

export default QRCodeImage;
